<section class="pt-4 px-2 px-lg-0">
	<h2>{{ "menu.privacy" | translate }}</h2>
	<div
		class="free-text-page pt-3"
		[innerHTML]="'privacy-policy.html-full' | translate | safeHtml"
	></div>
</section>